<template>
  <section class="px-4 sm:px-6 md:px-10 lg:px-40 mt-4">
    <div v-if="loading" class="aspect-[16/6] rounded-2xl bg-slate-100 animate-pulse" />
    <div v-else-if="slides.length" class="relative rounded-2xl overflow-hidden shadow-card">
      <div class="relative aspect-[16/7] sm:aspect-[16/6] md:aspect-[21/8] bg-slate-100">
        <transition name="hero-fade">
          <img
            :key="active"
            :src="slides[active]"
            alt=""
            class="absolute inset-0 w-full h-full object-cover object-center"
            fetchpriority="high"
            decoding="async"
          />
        </transition>
      </div>

      <!-- Arrows (only when multiple slides) -->
      <template v-if="slides.length > 1">
        <button
          type="button" :aria-label="$t('rail.prev')"
          class="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/85 hover:bg-white text-slate-700 flex items-center justify-center shadow"
          @click="go(-1)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
        </button>
        <button
          type="button" :aria-label="$t('rail.next')"
          class="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/85 hover:bg-white text-slate-700 flex items-center justify-center shadow"
          @click="go(1)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
        </button>

        <!-- Dots -->
        <div class="absolute inset-x-0 bottom-3 flex items-center justify-center gap-2">
          <button
            v-for="(s, i) in slides" :key="i"
            type="button"
            :aria-label="`Slide ${i + 1}`"
            :class="[
              'h-2 rounded-full transition-all',
              i === active ? 'w-6 bg-white' : 'w-2 bg-white/60 hover:bg-white/80',
            ]"
            @click="active = i; resetTimer()"
          />
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroCarousel',
  props: {
    images:  { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    interval: { type: Number, default: 6000 },
  },
  data() {
    return {
      active: 0,
      timer: null,
    };
  },
  computed: {
    slides() {
      return (this.images || [])
        .map((it) => (typeof it === 'string' ? it : (it?.image_url || it?.image || null)))
        .filter(Boolean);
    },
  },
  watch: {
    slides() { this.active = 0; this.resetTimer(); },
  },
  mounted() { this.resetTimer(); },
  beforeUnmount() { this.clearTimer(); },
  methods: {
    go(direction) {
      const len = this.slides.length;
      if (!len) return;
      this.active = (this.active + direction + len) % len;
      this.resetTimer();
    },
    clearTimer() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    },
    resetTimer() {
      this.clearTimer();
      if (this.slides.length > 1) {
        this.timer = setInterval(() => this.go(1), this.interval);
      }
    },
  },
};
</script>

<style scoped>
.hero-fade-enter-active,
.hero-fade-leave-active {
  transition: opacity 0.5s ease;
}
.hero-fade-enter-from,
.hero-fade-leave-to { opacity: 0; }
</style>
